export type PdsMode = "light" | "dark";

export const schemes = {
  dark: {
    bg: "#06090f",
    chrome: "#0a0f17",
    panel: "#0c131d",
    panel2: "#0a121c",
    border: "#182536",
    border2: "#142230",
    text: "#E6EDF3",
    textHi: "#FFFFFF",
    muted: "#8CA0B3",
    faint: "#5f7285",
    label: "#6c8090",
    accent: "#00B4D8",
  },
  light: {
    bg: "#EEF2F6",
    chrome: "#FFFFFF",
    panel: "#FFFFFF",
    panel2: "#F4F7FA",
    border: "#DCE3EA",
    border2: "#E7ECF1",
    text: "#0B1F3A",
    textHi: "#0B1F3A",
    muted: "#5A6B7B",
    faint: "#8090A0",
    label: "#6B7A88",
    accent: "#00B4D8",
  },
} as const;

export const modules = {
  cultivation: "#35C08A",
  processing: "#00B4D8",
  finance: "#9b8cf5",
  maintenance: "#3ec4b6",
} as const;

export const stages = {
  clone: "#3ec4b6",
  veg: "#35C08A",
  flower: "#9b8cf5",
  drying: "#E5A13A",
} as const;

export const statusColors = {
  success: "#35C08A",
  warning: "#E5A13A",
  error: "#E15B4C",
  info: "#00B4D8",
} as const;

export const radii = { panel: 5, control: 4, pill: 999 } as const;
export const fonts = {
  display: '"Oswald", sans-serif',
  body: '"Montserrat", sans-serif',
  data: '"IBM Plex Mono", monospace',
} as const;
export const layout = { topbarHeight: 55, sidebarWidth: 232 } as const;
export const breakpoints = {
  mobile: 0,
  tablet: 768,
  laptop: 1280,
  wide: 1440,
} as const;

export const getTokens = (mode: PdsMode) => schemes[mode];
